import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";
import { getUICompat } from '@utils/UICompat';

const { Spin } = getUICompat()
class Loading {
     loadingView = observer(({ appState, rootId }) => (
        <Spin container={document.getElementById(rootId)} spinning={appState.loadingCount > 0 ? true : false} />
      ));
    constructor() {
      makeAutoObservable(this);
    }
    addLoading (props) {
        let div = document.createElement('div');
        const rootId = props.params?.diworkCode || props.query?.diworkCode || props.params?.billNo || 'root'
        div.setAttribute('id', `ynf-Loading_${rootId}`);
        document.body?.append(div)
        let ele = <this.loadingView appState={props} rootId={rootId} />
        ReactDOM.render(ele, document.querySelector(`#ynf-Loading_${rootId}`))
      }

  }
export default Loading
